import React from 'react';
import AuthForm, { STATE_LOGIN } from 'components/AuthForm';
import { Card, Col, Row } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import logoqa from '../assets/img/logo/icon2.png';
import login1 from '../assets/img/logo/login1.png';

import './AuthPageStyle.css';

const AuthPage = props => {
  const history = useHistory();
  const theme = useTheme();
  const matchesmallscreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleAuthState = authState => {
    if (authState === STATE_LOGIN) {
      history.push('/login');
    } else {
      history.push('/signup');
    }
  };

  const handleLogoClick = () => {
    history.push('/');
  };

  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
      className="loginbg"
    >
      <Row
        className="bg-white w-75"
        style={{
          borderRadius: '20px',
          boxShadow:
            'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
        }}
      >
        {!matchesmallscreen && (
          <Col md={6} lg={6} className="p-0">
            <img
              src={login1}
              width="100%"
              style={{
                objectFit: 'cover',
                borderTopLeftRadius: '20px',
                borderBottomLeftRadius: '20px',
              }}
              alt="loginimage"
            />
          </Col>
        )}

        <Col
          lg={matchesmallscreen ? 12 : 6}
          className="d-flex justify-content-center align-items-center"
        >
          <Card body style={{ border: 'none', boxShadow: 'none' }}>
            <AuthForm
              authState={props.authState}
              onChangeAuthState={handleAuthState}
              onLogoClick={handleLogoClick}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AuthPage;
